import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getFeatureFlags = (token: string, backend: string) => {
    return fetch(`${getApiUrl(backend)}current_tenant_feature_flags`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getFeatureFlags